import React from "react";
import Button from "@insightfulscience/atomic-react/Button";
import Spinner from "@insightfulscience/atomic-react/Spinner";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import SmartForm from "@insightfulscience/smart-react/SmartForm";
import useFormAction from "@insightfulscience/smart-react/hooks/useFormAction";
import NextLink from "@insightfulscience/smart-react/NextLink";
import { useLocale } from "@insightfulscience/smart-react/i18";
import Block from "@insightfulscience/atomic-react/Block";
import Alert from "@insightfulscience/atomic-react/Alert";

import { initialState, validateForm } from "./form";
import { signInFormAction, EINVALID_EMAIL_OR_PASSWORD } from "./action";
import routes from "../routes";

function SignInForm() {
	const [t] = useLocale("auth-login-form");
	const [action, { error, reset, isLoading }] = useFormAction(signInFormAction);

	return (
		<>
			{isLoading && <Spinner />}
			{!!error && error !== EINVALID_EMAIL_OR_PASSWORD && (
				<Alert status="error" className="mb-4">
					{t(error)}
				</Alert>
			)}
			<SmartForm
				textRender={t}
				id="signInForm"
				{...{ initialState, validateForm, action }}
				onTouched={reset}
			>
				<SmartForm.Field
					type="email"
					fieldClassName="mb-8"
					required
					label={t("EMAIL")}
					error={error === EINVALID_EMAIL_OR_PASSWORD && error}
					name="email"
					maxLength={100}
					data-qa-selector="emailAuth"
					disabled={isLoading}
				/>
				<SmartForm.Field
					type="password"
					fieldClassName="mb-8"
					required
					label={t("PASSWORD")}
					error={error === EINVALID_EMAIL_OR_PASSWORD && error}
					name="password"
					maxLength={73}
					data-qa-selector="passwordAuth"
					disabled={isLoading}
					hint={
						<div className="field__link">
							<NextLink
								size="s"
								href={routes.auth.forgotPassword}
								data-qa-selector="signIn-forgot-link"
							>
								{t("FORGOT_PASSWORD")}
							</NextLink>
						</div>
					}
				/>
				<Row>
					<Col spacing={{ mt: 4, mb: 2 }}>
						<Block sx={{ textAlign: "center" }}>
							<Button type="submit" disabled={isLoading} data-qa-selector="signIn-submit-button">
								{t("SUBMIT")}
							</Button>
						</Block>
					</Col>
				</Row>
			</SmartForm>
		</>
	);
}

export default SignInForm;
